export enum EtapaAvisoLembreteEnum {
  NENHUM = 'NENHUM',
  UMA_HORA = 'UMA_HORA',
  TRINTA_MINUTOS = 'TRINTA_MINUTOS',
  CINCO_MINUTOS = 'CINCO_MINUTOS',
  EXECUCAO = 'EXECUCAO',
}
